import { useState } from "react";

const rows = [
  {
    maand: "Week 0",
    titel: "Selectie & intake",
    korte: "Intake, nulmeting, kennismaken",
    inhoud:
      "Gemeente levert deelnemersbestand. Intake per deelnemer, nulmeting op dagstructuur, zelfredzaamheid, ervaren perspectief en participatie.",
    accent: "#E06B3F",
  },
  {
    maand: "Week 1-3",
    titel: "Startpunt & Rugzak",
    korte: "Landen, vertrouwen, patronen zichtbaar maken",
    inhoud:
      "Vaste groep, twee trainers, gezamenlijke lunch en buddy-koppeling. Waar sta je nu? Wat draag je mee? Zonder oordeel vastleggen.",
    accent: "#97B79D",
  },
  {
    maand: "Week 4-6",
    titel: "Rem",
    korte: "Benoemen wat vastzet",
    inhoud:
      "Overtuigingen, systeem, praktische belemmeringen. Individuele gesprekken naast groepswerk. Eerste kleine experimenten in het echte leven.",
    accent: "#E06B3F",
  },
  {
    maand: "Week 7-9",
    titel: "Vonk",
    korte: "Doen, uitproberen, ontdekken",
    inhoud:
      "Waar wordt het lichter? Meelopen bij partners, korte werk-proeverijen, kleine dingen die energie geven. Tussenmeting.",
    accent: "#F0B98D",
  },
  {
    maand: "Week 10-12",
    titel: "Eerste stap & overdracht",
    korte: "Eindmeting, certificaat, warme overdracht",
    inhoud:
      "Terugblik, meetpunten, een concrete haalbare eerste stap. Warme overdracht naar VERDER, opleiding, werk of een bestaand traject.",
    accent: "#78A85A",
  },
];

export default function PilotTimeline() {
  const [open, setOpen] = useState(null);
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-3" data-testid="pilot-timeline">
      {rows.map((r, i) => (
        <button
          key={r.maand}
          type="button"
          onClick={() => setOpen(open === i ? null : i)}
          className={`text-left rounded-2xl border p-5 transition-all ${
            open === i ? "bg-ll-navy text-ll-cream border-transparent" : "bg-white border-ll-ink/15 hover:border-ll-ink"
          }`}
          data-testid={`pilot-week-${i}`}
        >
          <p className="text-[10px] uppercase tracking-[0.3em]" style={{ color: r.accent }}>
            {r.maand}
          </p>
          <p className="mt-3 font-heading text-2xl leading-tight font-light">
            {r.titel}
          </p>
          <p className={`mt-2 text-sm ${open === i ? "text-ll-cream/80" : "text-ll-ink/70"}`}>
            {r.korte}
          </p>
          {open === i && (
            <p className="mt-4 text-sm leading-relaxed text-ll-cream/85">
              {r.inhoud}
            </p>
          )}
        </button>
      ))}
    </div>
  );
}
